module.exports = __webpack_public_path__ + "static/dining.b4187060.jpg";